module.exports = __webpack_public_path__ + "img/download.1e0135e8.svg";